<template>
    <el-dialog title="用户地址" :visible.sync="showModal" :close-on-click-modal="false" :destroy-on-close="true"
        width="620px">
        <el-form ref="form" :model="addressData" label-width="60px">
            <el-form-item label="收件人">
                <el-input placeholder="请输入内容" :value="addressData.user_name" />
            </el-form-item>
            <el-form-item label="电话">
                <el-input placeholder="请输入内容" :value="addressData.user_phone" />
            </el-form-item>
            <el-form-item label="邮编">
                <el-input placeholder="请输入内容" :value="addressData.postal_code" />
            </el-form-item>
            <el-form-item label="地址">
                <el-input placeholder="请输入内容" :value="addressData.address_details" />
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="trunOff">确定</el-button>
                <el-button @click="copyAddress">复制地址</el-button>
            </el-form-item>
        </el-form>
    </el-dialog>
</template>

<script>
export default {
    data: () => ({}),
    props: {
        // 展示
        show: {
            default: false,
            type: Boolean
        },
        addressData: Object
    },
    methods: {
        trunOff() {
            this.showModal = false
        },
        copyAddress() {
            const { user_name, user_phone, postal_code, address_details } = this.addressData

            console.log(user_name, user_phone, postal_code, address_details)

            // document.body.appendChild(aux);
            // aux.select();
            // document.execCommand("copy");
            // this.$message({
            //     message: '已复制到剪贴板',
            //     type: 'success'
            // });
            // document.body.removeChild(aux);

            var aux = document.createElement("input");
            aux.setAttribute("value", `${user_name} ${user_phone} ${postal_code} ${address_details}`);
            document.body.appendChild(aux);
            aux.select();
            document.execCommand("copy");
            this.$message({
                message: '已复制到剪贴板',
                type: 'success'
            });
            document.body.removeChild(aux);
        }
    },
    computed: {
        showModal: {
            get() {
                return this.show;
            },
            set(val) {
                this.$emit('update:show', val);
            }
        },
    },
    mounted() {
        console.log(this.addressData)
    }
}
</script>

<style lang="scss" scoped>

</style>